import { combineSlices } from '@reduxjs/toolkit';
import { aiBotConfigSlice } from '@/modules/AiBotConfig';
import { akeneoSyncSlice } from '@/modules/AkeneoSync';
import { authSlice } from '@/modules/Auth';
import { blogPostsSlice } from '@/modules/Blog/feature';
import { brandsSlice } from '@/modules/Brands';
import { categorySlice } from '@/modules/Categories';
import { channelListenerMiddleware, channelSlice } from '@/modules/Channels';
import { faqsSlice } from '@/modules/Faq';
import { faqChannelsSlice } from '@/modules/FaqChannels';
import { generalFaqSlice } from '@/modules/GeneralFaq';
import { faqCommonSlice } from '@/modules/FaqCommon';
import { suggestedFaqSlice } from '@/modules/SuggestedFaq';
import { suggestedFaqDetailsSlice } from '@/modules/SuggestedFaqDetails';
import { conversationsSlice } from '@/modules/Conversations';
import { conversationDetailsSlice } from '@/modules/ConversationDetails';
import { interLinksSlice } from '@/modules/LinkingTool';
import { metatagsSlice } from '@/modules/Metatags';
import { pagesSlice } from '@/modules/Pages';
import { productSlice } from '@/modules/Products';
import { redirectsSlice } from '@/modules/Redirects';
import { reviewsSlice } from '@/modules/Reviews';
import { robotsSlice } from '@/modules/RobotsTxt';
import { settingsSlice } from '@/modules/Settings';
import { shippingPricesSlice } from '@/modules/ShippingPrices';
import { uploadFileSlice } from '@/modules/Upload/feature/slice';
import { variablesSlice } from '@/modules/Variables';
import { deliverySettingsSlice } from '@/modules/DeliverySettings';
import { googleMerchantSettingsSlice } from '@/modules/MerchantSettings';
import { googleMerchantSyncSlice } from '@/modules/MerchantSync';
import { paymentMethodsSlice } from '@/modules/PaymentMethods';
import { couponsSlice } from '@/modules/Coupons/feature';
import { websitesSlice } from '@/modules/Websites';
import { llmChannelTemplateSlice } from '@/modules/LLMChannelTemplate';
import { llmConfigSlice } from '@/modules/LLMConfig';
import { llmTemplateVariablesSlice } from '@/modules/LLMTemplateCommon';
import { llmTemplatesSlice } from '@/modules/LLMTemplates';
import { llmTemplateDetailsSlice } from '@/modules/LLMTemplateDetails';
import { pushOrderSlice } from '@/modules/PushOrders';

export const rootReducer = combineSlices(
  authSlice,
  aiBotConfigSlice,
  akeneoSyncSlice,
  channelSlice,
  brandsSlice,
  settingsSlice,
  deliverySettingsSlice,
  reviewsSlice,
  productSlice,
  shippingPricesSlice,
  pagesSlice,
  interLinksSlice,
  metatagsSlice,
  googleMerchantSettingsSlice,
  googleMerchantSyncSlice,
  robotsSlice,
  redirectsSlice,
  llmConfigSlice,
  llmChannelTemplateSlice,
  llmTemplateVariablesSlice,
  llmTemplatesSlice,
  llmTemplateDetailsSlice,
  variablesSlice,
  categorySlice,
  faqsSlice,
  faqChannelsSlice,
  generalFaqSlice,
  faqCommonSlice,
  suggestedFaqSlice,
  suggestedFaqDetailsSlice,
  conversationsSlice,
  conversationDetailsSlice,
  blogPostsSlice,
  uploadFileSlice,
  paymentMethodsSlice,
  couponsSlice,
  websitesSlice,
  pushOrderSlice,
);

export const middlewares = [channelListenerMiddleware.middleware];
